import logoImage from '@/assets/images/logo.png';
import { Link } from 'react-router-dom';

const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
  e.preventDefault();
  const id = href.replace('#', '');
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

const services = [
  'Inteligência Artificial',
  'Desenvolvimento de Software',
  'Consultoria Tecnológica',
  'Análise de Dados',
  'Automação de Processos',
  'Cloud & Infraestrutura',
];

const links = [
  { label: 'Sobre Nós', href: '#about' },
  { label: 'Serviços', href: '#services' },
  { label: 'Soluções', href: '#solutions' },
  { label: 'IA', href: '#ai' },
  { label: 'Contato', href: '#contact' },
];

export default function Footer() {
  return (
    <footer className="bg-emerald-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className="flex items-center gap-2.5 cursor-pointer mb-4">
              <img
                src={logoImage}
                alt="Almadata Logo"
                className="h-9 w-auto"
              />
              <span className="font-bold text-lg font-sora tracking-tight">
                alma<span className="text-emerald-400">data</span>
              </span>
            </a>
            <p className="text-emerald-100/70 text-sm font-inter leading-relaxed mb-6">
              Transformamos dados em inteligência. Tecnologia com alma para o seu negócio crescer mais e melhor.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-linkedin-fill', href: 'https://linkedin.com' },
                { icon: 'ri-instagram-line', href: 'https://instagram.com' },
                { icon: 'ri-github-fill', href: 'https://github.com' },
                { icon: 'ri-whatsapp-line', href: 'https://wa.me/5561992232205' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow noopener"
                  target="_blank"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-emerald-500 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold font-sora text-sm uppercase tracking-wider text-emerald-400 mb-5">
              <a href="#services" onClick={(e) => handleNavClick(e, '#services')}>Serviços</a>
            </h4>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    onClick={(e) => handleNavClick(e, '#services')}
                    className="text-sm text-emerald-100/70 hover:text-emerald-400 transition-colors cursor-pointer font-inter"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold font-sora text-sm uppercase tracking-wider text-emerald-400 mb-5">
              Navegação
            </h4>
            <ul className="space-y-2.5">
              {links.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => handleNavClick(e, l.href)}
                    className="text-sm text-emerald-100/70 hover:text-emerald-400 transition-colors cursor-pointer font-inter"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold font-sora text-sm uppercase tracking-wider text-emerald-400 mb-5">
              Contato
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-mail-line text-emerald-400 text-base" />
                </div>
                <span className="text-sm text-emerald-100/70 font-inter">contato@almadata.com.br</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-phone-line text-emerald-400 text-base" />
                </div>
                <span className="text-sm text-emerald-100/70 font-inter">+55 (61) 99223-2205</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-map-pin-line text-emerald-400 text-base" />
                </div>
                <span className="text-sm text-emerald-100/70 font-inter">São Roque, SP — Brasil</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-emerald-100/50 font-inter">
            © 2026 Almadata Soluções Tecnológicas. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/terms-of-use" className="text-xs text-emerald-100/50 hover:text-emerald-400 transition-colors font-inter">
              Termos de Uso
            </Link>
            <span className="text-emerald-100/30">|</span>
            <Link to="/privacy-policy" className="text-xs text-emerald-100/50 hover:text-emerald-400 transition-colors font-inter">
              Política de Privacidade
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
